import { formatDistance as formatDistanceFns, format, Locale } from 'date-fns';
import {
  be,
  bg,
  bs,
  cs,
  da,
  de,
  el,
  es,
  fi,
  fr,
  he,
  hr,
  hu,
  it,
  lt,
  mk,
  nb,
  nl,
  pl,
  pt,
  ro,
  ru,
  se,
  sl,
  sq,
  sr,
  sv,
  tr,
  uk,
  arSA,
  arMA,
  enAU,
  enCA,
  enIN,
  enNZ,
  frCH,
  ptBR,
  nlBE,
  frCA,
  enUS,
  enGB,
} from 'date-fns/locale';
import { AVAILABLE_LOCALES_POP_UP } from '../core/constants/locale';

export const dateUtils = (date: Date | number) => ({
  diffMinuteFromNow() {
    const previous = +date;
    const now = Date.now();
    return (now - previous) / (1000 * 60);
  },
});

const mapLocal = {
  ar: arSA,
  be,
  bg,
  bs,
  cs,
  da,
  de,
  el,
  es,
  fi,
  fr,
  he,
  hr,
  hu,
  it,
  lt,
  mk,
  nb,
  nl,
  pl,
  pt,
  ro,
  ru,
  se,
  sl,
  sq,
  sr,
  sv,
  tr,
  uk,
  fr_fr: fr,
  fr_ca: frCA,
  fr_ch: frCH,
  en: enUS,
  en_us: enUS,
  en_gb: enGB,
  en_au: enAU,
  en_ca: enCA,
  en_in: enIN,
  en_nz: enNZ,
  es_co: es,
  es_es: es,
  it_it: it,
  pl_pl: pl,
  pt_pt: pt,
  pt_br: ptBR,
  ru_ru: ru,
  tr_tr: tr,
  ar_sa: arSA,
  ar_ma: arMA,
  nl_nl: nl,
  nl_br: nlBE,
  de_de: de,
  ro_ro: ro,
};

const selectLocale = (localeStr?: string): Locale => {
  const localeUnderScore = String(localeStr.replace('-', '_')).toLowerCase()
  const localHyphen = String(localeStr.replace('_', '-'))
  const fullStringMatch = mapLocal[localeUnderScore]
  if (fullStringMatch) {
    return fullStringMatch
  }
  const languageMatch = mapLocal[localeUnderScore.split('_')[0]]
  if (!!AVAILABLE_LOCALES_POP_UP.includes(localHyphen as any) && languageMatch) {
    return languageMatch
  }
  return enUS
};

export const formatDistance = (date: Date | number, localeStr?: string) => {
  return formatDistanceFns(date, Date.now(), {
    locale: selectLocale(localeStr),
  });
};

export const localizeDay = (day, localeStr?: string) => {
  return selectLocale(localeStr).localize.day(day, {
    width: 'abbreviated',
    context: 'formatting',
  });
};

export const formatHour = (date: Date | number, localeStr?: string) => {
  return format(date, 'h:mm a', {
    locale: selectLocale(localeStr),
  })
}

export const WeekDayToNumber = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const WeekDayByArray = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
